import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const usePermisos = () => {

    const { idTipoUsuario, idUsuarioCitas, idJuzgado, idMateria, permisos, aplicacionesOnline } = useSelector( state => state.auth );

    const [loading, setLoading] = useState( true );
    const [tipoUsuario, setTipoUsuario] = useState( 0 );
    const [banderaCitas, setBanderaCitas] = useState( false );
    const [banderaBuzon, setBanderaBuzon] = useState( false );
    const [banderaExpedienteVirtual, setBanderaExpedienteVirtual] = useState( false );
    const [banderaBoletas, setBanderaBoletas] = useState( false );    

    const [banderaOnlineCitas, setBanderaOnlineCitas] = useState( true );
    const [banderaOnlineBuzon, setBanderaOnlineBuzon] = useState( true );
    const [banderaOnlineExpedienteVirtual, setBanderaOnlineExpedienteVirtual] = useState( true );
    const [banderaOnlineBoletas, setBanderaOnlineBoletas] = useState( true );    

    useEffect(() => {
        
        if( permisos?.CITAS && idTipoUsuario === 2 ){ setBanderaCitas( true ); }
        if( permisos?.BEDP && ( idTipoUsuario === 1 || idTipoUsuario === 2 || idTipoUsuario === 5 || idTipoUsuario === 14 ) ){ setBanderaBuzon( true ); }
        if( permisos?.['EV2.0'] && ( idTipoUsuario === 1 || idTipoUsuario === 2 || idTipoUsuario === 14 ) ){ setBanderaExpedienteVirtual( true ); }
        if( permisos?.BEGA && ( idTipoUsuario === 1 || idTipoUsuario === 2 ) ){ setBanderaBoletas( true ); }
        
    }, [ permisos, idTipoUsuario ])

    useEffect(() => {

        if( idTipoUsuario === 2 ){

            setBanderaOnlineCitas( aplicacionesOnline?.CITAS ?? false );
            setBanderaOnlineBuzon( aplicacionesOnline?.BEDP ?? false );
            setBanderaOnlineExpedienteVirtual( aplicacionesOnline?.['EV2.0'] ?? false );
            setBanderaOnlineBoletas( aplicacionesOnline?.BEGA ?? false );

        }
                
    }, [ aplicacionesOnline, idTipoUsuario ])

    useEffect(() => {
              
        setTipoUsuario( idTipoUsuario );        
        
        if( idTipoUsuario !== 0){
            setLoading( false );
        }
        
    }, [ idTipoUsuario ])

    return {
        loading,
        idUsuarioCitas,
        tipoUsuario,
        idJuzgado,
        idMateria,
        banderaCitas,
        banderaBuzon, 
        banderaExpedienteVirtual,
        banderaBoletas,
        banderaOnlineCitas,
        banderaOnlineBuzon, 
        banderaOnlineExpedienteVirtual,
        banderaOnlineBoletas,
    }

}